<div
	fxlayout="column"
	fxLayoutAlign.gt-sm="space-between center "
	ngClass.gt-sm="p-t-xs"
>
	<!-- Container for the links and icons -->
	<div fxlayout="column" fxLayoutGap="2%">
		<div
			class="div3"
			fxLayout="row"
			fxLayout.sm="column"
			fxLayout.xs="column"
			fxLayoutAlign="space-between center"
			fxLayoutAlign.sm="start start"
			fxLayoutAlign.xs="start start"
			fxLayoutGap="2%"
		>
			<!-- Link to Privacy and Cookies page -->
			<a mat-button class="footer-link" i18n="@@footer_label_privacyAndCookies" [href]="privacyHref"
				>Privacy and cookies</a
			>
			<!-- Link to Terms and Conditions page -->
			<a mat-button class="footer-link" i18n="@@footer_label_TermsAndConditions" [href]="termsHref"
				>Terms and Conditions</a
			>
			<!-- Link to Copyright page -->
			<a mat-button class="footer-link" i18n="@@footer_label_copyright" [href]="copyrightHref"
				>Copyright &copy; 2020 whydonate</a
			>
			<!-- Button to open Cookie Settings modal -->
			<a mat-button (click)="openCookieSettings()">
				<div fxLayoutAlign="start center">
					<span class="material-icons-outlined">
						cookie
					</span>
					<span i18n="@@footer_label_cookieSettings">&nbsp;Cookie Settings</span>
				</div>
			</a>
		</div>
	</div>

	<!-- Container for the certification and partner badges -->
	<div
		fxlayout="column"
		fxLayoutAlign="start center"
		fxLayoutGap="2%"
		ngClass.lt-md="p-t-m p-l-xs"
	>
		<!-- Stripe Partner Badge -->
		<img
			fxFlex="50"
			src="https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/StripePartnerBadge/public"
		/>
		<!-- ISO Certification Badge -->
		<img
			fxFlex="10"
			src="https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/iso/public"
		/>
		<!-- SSL Certification Badge -->
		<img
			fxFlex="10"
			src="https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/SSL/public"
		/>
	</div>
</div>
